import { render, staticRenderFns } from "./LinksFooter.vue?vue&type=template&id=2629f573"
import script from "./LinksFooter.vue?vue&type=script&lang=js"
export * from "./LinksFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports